import { Component, HostListener, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { TooltipBubbleComponent } from '../tooltip-bubble/tooltip-bubble.component';
import { NativeService } from '@app/shared/services/native.service';

const ORIENTATION_CHECK_DEBOUNCE_MS = 200;

@Component({
  selector: 'slotcom-warning-landscape',
  templateUrl: './warning-landscape.component.html',
  styleUrls: ['./warning-landscape.component.scss'],
  standalone: true,
  imports: [TooltipBubbleComponent, SharedModule],
})
export class WarningLandscapeComponent implements OnInit, OnDestroy {
  private debounceTimeoutId: ReturnType<typeof setTimeout> | undefined;

  private readonly nativeService = inject(NativeService);

  @HostListener('window:resize') onResizeScreen() {
    this.scheduleOrientationCheck();
  }

  @HostListener('window:orientationchange') onOrientationChange() {
    this.scheduleOrientationCheck();
  }

  showLandscapeWarning = signal(false);

  ngOnInit(): void {
    this.checkOrientation();
  }

  ngOnDestroy(): void {
    clearTimeout(this.debounceTimeoutId);
  }

  private scheduleOrientationCheck(): void {
    clearTimeout(this.debounceTimeoutId);
    this.debounceTimeoutId = setTimeout(() => this.checkOrientation(), ORIENTATION_CHECK_DEBOUNCE_MS);
  }

  private checkOrientation(): void {
    this.showLandscapeWarning.set(this.isPortraitViewport());
  }

  private isPortraitViewport(): boolean {
    const matchesPortraitMedia = window.matchMedia('(orientation: portrait)').matches;
    const isTallerThanWide = window.innerHeight > window.innerWidth;

    return this.nativeService.isNative() && matchesPortraitMedia && isTallerThanWide;
  }
}
